import { http } from '../../config/axios'

const findRepresentante = (params: any): Promise<any> => {

  const queryParams = params
    ? Object.keys(params)
      .map((k) => encodeURIComponent(params[k]))
      .join('/')
    : '';


  return http
    .get('api/representante/find/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findRepresentante', error)
      throw Error(error.response.data)
    })
}

export default findRepresentante;
